import Vue from 'vue'
/**
 *
 *
 * @param {Array} arr 需要被初始化的数组
 * @param {String} initType ‘init’: status赋值为false; 'assign'：status赋值为true
 * @param {any} parent 递归传递的上一个数组
 */
function initAdminTree (arr, initType, parent) {
  arr.forEach((v, i, t) => {
    const {remark, authority, parameters, type, url, verify, id, display, isOpen} = v
    let temp = {
      text: remark,
      name: authority,
      parameters: parameters || '',
      type,
      url,
      verify,
      id,
      display,
      isOpen,
      treeIndex: parent ? `${parent.treeIndex},${authority}` : `${authority}`,
    }
    switch (initType) {
      case 'init':
        temp.status = false
        break
      case 'assign':
        temp.status = true
        break
    }
    Vue.set(t, i, temp)
    if (v.children) {
      t[i].children = v.children
      initAdminTree(v.children, initType, t[i])
    }
  })
}

/**
 *
 *
 * @param {any} tree 被查找的深层对象数组
 * @param {any} treeIndex 查找的treeIndex字段
 * @returns 返回查找到的节点
 */
function getTreeIndex (tree, treeIndex) {
  const indexs = treeIndex.split(',')
  let node
  indexs.forEach((v, i) => {
    if (i === 0) {
      node = tree.find(k => k.name === indexs[i])
    } else {
      node = node.children.find(k => k.name === v)
    }
  })
  return node
}

function hasPermissionStatus (permissionList, permissionKey) {
  return Boolean(permissionList && permissionList[permissionKey] && permissionList[permissionKey].status)
}

export {
  initAdminTree,
  getTreeIndex,
  hasPermissionStatus,
}
